// `toMinHHMM` / `fromMinHHMM` moved to @starpoint/engine (#183). They had
// already been DUPLICATED verbatim into the engine's time module, which is the
// fork CLAUDE.md warns about — one of the two would eventually be fixed alone.
// Re-exported here so every existing call-site is unchanged.
export { toMinHHMM, fromMinHHMM } from '@starpoint/engine';

// ============================================================
// DATE / TIME HELPERS — extracted from the former monolith (Phase 3, incremental split).
//
// Pure 'HH:MM' <-> minutes-since-midnight helpers shared by several engines
// (booking, banepad, seriespill). No storage, no React.
//
// IMPORTANT (HANDOVER §13): never use toISOString() to derive a local
// 'YYYY-MM-DD' date — it shifts the day in UTC+ zones. These helpers only
// convert clock times and intentionally preserve the original logic verbatim.
// ============================================================

/** Parse 'HH:MM' into minutes since midnight. Non-strings / empty -> 0. */

/** Format minutes since midnight back to 'HH:MM', wrapping across midnight. */

// ─── Tournament default-date helpers (extracted from the former monolith, PR-AL) ───

export function nextWeekday(targetDay: number): string {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  let diff = (targetDay - today.getDay() + 7) % 7;
  if (diff === 0) diff = 7; // today = that day → take next week
  const d = new Date(today);
  d.setDate(today.getDate() + diff);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function defaultPadel24Dates(): { fredag: string; lordag: string } {
  const fredag = nextWeekday(5); // 5 = Friday
  // Saturday is the day after Friday
  const lorDate = new Date(fredag + 'T00:00:00');
  lorDate.setDate(lorDate.getDate() + 1);
  const y = lorDate.getFullYear();
  const m = String(lorDate.getMonth() + 1).padStart(2, '0');
  const day = String(lorDate.getDate()).padStart(2, '0');
  return { fredag, lordag: `${y}-${m}-${day}` };
}

export function nextWeekendDates(): { friday: string; saturday: string; sunday: string } {
  const fmt = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${dd}`;
  };
  const today = new Date();
  const daysUntilSat = (6 - today.getDay() + 7) % 7; // 0 = today is Saturday
  const sat = new Date(today);
  sat.setDate(today.getDate() + daysUntilSat);
  const sun = new Date(sat);
  sun.setDate(sat.getDate() + 1);
  const fri = new Date(sat);
  fri.setDate(sat.getDate() - 1);
  return { friday: fmt(fri), saturday: fmt(sat), sunday: fmt(sun) };
}
